var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDate({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 25,
    viewBox: "0 0 24 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_2143_15185)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M16.5 10.25C16.5 10.0511 16.579 9.86032 16.7197 9.71967C16.8603 9.57902 17.0511 9.5 17.25 9.5H18.75C18.9489 9.5 19.1397 9.57902 19.2803 9.71967C19.421 9.86032 19.5 10.0511 19.5 10.25V11.75C19.5 11.9489 19.421 12.1397 19.2803 12.2803C19.1397 12.421 18.9489 12.5 18.75 12.5H17.25C17.0511 12.5 16.8603 12.421 16.7197 12.2803C16.579 12.1397 16.5 11.9489 16.5 11.75V10.25Z",
    fill: "#ADADAD"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M5.25 0.5C5.44891 0.5 5.63968 0.579018 5.78033 0.71967C5.92098 0.860322 6 1.05109 6 1.25V2H18V1.25C18 1.05109 18.079 0.860322 18.2197 0.71967C18.3603 0.579018 18.5511 0.5 18.75 0.5C18.9489 0.5 19.1397 0.579018 19.2803 0.71967C19.421 0.860322 19.5 1.05109 19.5 1.25V2H21C21.7956 2 22.5587 2.31607 23.1213 2.87868C23.6839 3.44129 24 4.20435 24 5V21.5C24 22.2956 23.6839 23.0587 23.1213 23.6213C22.5587 24.1839 21.7956 24.5 21 24.5H3C2.20435 24.5 1.44129 24.1839 0.87868 23.6213C0.316071 23.0587 0 22.2956 0 21.5V5C0 4.20435 0.316071 3.44129 0.87868 2.87868C1.44129 2.31607 2.20435 2 3 2H4.5V1.25C4.5 1.05109 4.57902 0.860322 4.71967 0.71967C4.86032 0.579018 5.05109 0.5 5.25 0.5ZM1.5 6.5V21.5C1.5 21.8978 1.65804 22.2794 1.93934 22.5607C2.22064 22.842 2.60218 23 3 23H21C21.3978 23 21.7794 22.842 22.0607 22.5607C22.342 22.2794 22.5 21.8978 22.5 21.5V6.5H1.5Z",
    fill: "#ADADAD"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_2143_15185"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    fill: "white",
    transform: "translate(0 0.5)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDate);
export default __webpack_public_path__ + "static/media/date.f38afe5c08033b752cf98083e1cc0543.svg";
export { ForwardRef as ReactComponent };